import { TEventsCardState } from './types';

export function getEventCard(state: TEventsCardState) {
  return state.dataCardEvent;
}
